import { ComponentLocatorMap } from '../types/ComponentLocatorMap';

export const rateComponent = {
  aprPercent: 'rate.apr-percent',
  paymentAmount: 'rate.payment-amount',
  root: 'rate.root',
  termMonths: 'rate.term-months',
} as const satisfies ComponentLocatorMap;
